var exports = {
  "Q": "ExpressionInfoBottomSheet.module__content___X0w1a2",
  "N": "ExpressionInfoBottomSheet.module__card___X0w1a2",
};

module.exports = exports;
